import { AntenaFormType } from 'app/antena/antena/components/AntenaForm/AntenaFormType';

export const createAntenaFormInitialValues = (): AntenaFormType => ({
  nombre: '',
  latitud: '',
  longitud: '',
  grupo_id: ''
});
